import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { FormGroup, FormControl, HelpBlock } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { Link } from 'react-router-dom';
// Import Selectors
import { trim } from 'lodash';
import { requestResetPassword } from '../../AuthActions';
import styles from './styles.css';

class ResetPage extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      success: false,
      errors: null,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  handleSubmit(data) {
    const { valid, location } = this.props;
    if (!valid) {
      return;
    }
    const query = queryString.parse(location.search);
    const { code } = query;
    this.setState({ loading: true, success: false, errors: null });
    this.props.dispatch(requestResetPassword(data.password, code))
      .then(
        () => {
          this.setState({ loading: false, success: true, errors: null });
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
          } else if (e.token) {
            e.message = e.token;
          }
          this.setState({ loading: false, success: false, errors: e });
          throw new SubmissionError(e);
        },
      );
  }

  renderField({
    input, label, type, meta: { touched, error },
  }) {
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        <FormControl {...input} placeholder={label} type={type} />
        <FormControl.Feedback />
        {touched && error && <HelpBlock className="text-left">{error}</HelpBlock>}
      </FormGroup>
    );
  }

  render() {
    const { handleSubmit, submitting } = this.props;
    const { errors, success, loading } = this.state;
    if (success) {
      return (
        <div>
          Your password has been reset. <br />
          Please <Link to="/signin/form">login in</Link> with your username and your new password.
          <p />
        </div>
      );
    }
    return (
      <div>
        <p className="text-left">Field the form below to reset your password</p>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Field disabled={submitting} name="password" type="password" component={this.renderField} label="Password" />
          <Field disabled={submitting} name="password_confirmation" type="password" component={this.renderField} label="Password Confirmation" />
          {errors !== null && errors.message !== undefined && <p className="text-danger">{errors.message}</p>}
          <button type="submit" disabled={submitting || loading} className="btn btn-primary btn-lg btn-default btn-block">
            Reset
          </button>
        </form>
        <p />
        <div>
          <Link to="/signin/form"><Fa name="times-circle" /> Cancel</Link>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {};
}

ResetPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  location: PropTypes.object.isRequired,
};
ResetPage.defaultProps = {
  onLoading: () => {},
  onSuccess: () => {},
};

ResetPage.contextTypes = {
  router: PropTypes.object,
};

const validate = (values) => {
  const errors = {};
  if (!values.password_confirmation) {
    errors.password_confirmation = 'Please enter your password again';
  }
  if (!values.password) {
    errors.password = 'Password is required';
  } else if (trim(values.password).length < 8) {
    errors.password = 'Please enter at least 8 characters';
  } else if (values.password_confirmation && values.password_confirmation !== values.password) {
    errors.password_confirmation = 'Password confirmation does not match';
  }
  return errors;
};


const ResetPasswordForm = reduxForm({
  form: 'resetPasswordForm',
  validate,
})(ResetPage);

export default connect(mapStateToProps)(ResetPasswordForm);
